import ChangeDetails from './ChangeDetails';

export default ChangeDetails;
